import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { Type } from "class-transformer";
import { EnaioCall } from "./EnaioCall";
import { EnaioUser } from "./EnaioUser";

export class EnaioCallUpdateUser extends EnaioCall <boolean> {
    @Type(() => EnaioUser)
    userInfo: EnaioUser;
    upsertFields: string[];
    getModelType(): AdvancedType {
        return AdvancedType.ofPrimitive("boolean");
    }

}
